export const rankings = {
  week: [
    { id: 'w-1', name: '顶流剧组换角风波', score: 96, trend: 'up', tag: '娱乐圈' },
    { id: 'w-2', name: '直播基地保底协议', score: 88, trend: 'up', tag: '网红圈' },
    { id: 'w-3', name: '打投工作室资金流向', score: 84, trend: 'flat', tag: '饭圈' },
    { id: 'w-4', name: '三重股权代持疑云', score: 79, trend: 'down', tag: '资本' },
    { id: 'w-5', name: '控评手册流出', score: 73, trend: 'up', tag: '饭圈' },
    { id: 'w-6', name: 'MCN同款人设孵化', score: 68, trend: 'flat', tag: '网红圈' },
    { id: 'w-7', name: '选角包装费争议', score: 61, trend: 'down', tag: '娱乐圈' },
    { id: 'w-8', name: '刷量平台定价表', score: 57, trend: 'flat', tag: '网红圈' },
  ],
  month: [
    { id: 'm-1', name: '热搜成本清单拆解', score: 94, trend: 'up', tag: '资本' },
    { id: 'm-2', name: '对赌改写开机名单', score: 90, trend: 'up', tag: '娱乐圈' },
    { id: 'm-3', name: '舆情处置三段式', score: 86, trend: 'flat', tag: '幕后推手' },
    { id: 'm-4', name: '粉丝集资代付通道', score: 81, trend: 'up', tag: '饭圈' },
    { id: 'm-5', name: 'MCN批量孵化疑云', score: 76, trend: 'down', tag: '网红圈' },
    { id: 'm-6', name: '渠道闭环投放', score: 71, trend: 'flat', tag: '娱乐圈' },
    { id: 'm-7', name: '多层外包结算路径', score: 65, trend: 'up', tag: '资本' },
    { id: 'm-8', name: '素材统一口径分发', score: 60, trend: 'down', tag: '幕后推手' },
  ],
};